import { WbmMainHeaderApi } from "@wbmason/main-header-api";
import { IFavoritesList } from "@wbmason/my-list-service";
import { useEffect, useState } from "react";
import ConfigProps from "../../constants/configProps";
import ConfigPropService from "../../utilities/configPropService";
import LoginUrlService from "../../utilities/loginUrlService";
import AddList from "./addList";
import { IManageLists } from "./manageLists";

export function ManageListsClient(props: IManageLists) {
  const {
    addToListEnabled,
    isLoggedIn,
    isCookied,
    productSet,
    listAction,
    pageName,
  } = props;

  const [manageGroupLists, setManageGroupLists] = useState(false);
  const [loginHref, setLoginHref] = useState("");

  useEffect(() => {
    const configPropsSub = ConfigPropService.get([
      ConfigProps.ManageGroupLists,
    ]).subscribe((configProps) => {
      setManageGroupLists(
        ConfigPropService.isYesOrTrue(configProps[ConfigProps.ManageGroupLists])
      );
    });

    const loginUrlSub = LoginUrlService.get().subscribe((loginUrl) => {
      setLoginHref(loginUrl);
    });

    return () => {
      configPropsSub.unsubscribe();
      loginUrlSub.unsubscribe();
    };
  }, []);

  const manageList = (response: IFavoritesList) => {
    WbmMainHeaderApi.updateList(response);
  };

  return (
    <>
      {addToListEnabled && (
        <AddList
          createList={manageList}
          updateList={manageList}
          loginHref={loginHref}
          authorized={isLoggedIn || isCookied}
          manageGroupLists={manageGroupLists}
          productSet={productSet}
          listAction={listAction}
          pageName={pageName}
        />
      )}
    </>
  );
}

export default ManageListsClient;
